import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Masonry from "react-masonry-css";
import Box from "@mui/material/Box";
import { useState } from "react";
import { Modal } from "../../components/Modal";
import "./style.css";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { useMediaQuery } from "react-responsive";
import ImageFadeIn from "../../components/ImageFadeIn";
import ElementFadeIn from "../../components/ElementFadeIn";
import { GameCard } from "./gameCard";
import Timer from "../../components/Timer";
import Game from "../../components/Game";
import { Skeleton } from "@mui/material";

const GameList = (props) => {
    const { games, noRecordFound } = props;
    const [openImageModal, setOpenImageModal] = useState(false);
    const [selectedGame, setSelectedGame] = useState(null);
    const [displayImages, setDisplayImages] = useState(false);
    const [displayModalContent, setDisplayModalContent] = useState(false);
    let [tries, setTries] = useState(0);

    const isDesktop = useMediaQuery({ minWidth: 1180 });
    const md = useMediaQuery({ maxWidth: 900, minWidth: 768 });
    const sm = useMediaQuery({ maxWidth: 767 });

    React.useEffect(() => {
        setDisplayImages(true);
    }, []);

    const handleCloseModal = () => {
        setDisplayModalContent(false);
        setTimeout(() => {
            setOpenImageModal(false);
        }, 500);
    };

    const handlePlay = (item) => {
        setTries(0);
        setSelectedGame(item);
        setOpenImageModal(true);
        setTimeout(() => {
            setDisplayModalContent(true);
        }, 200);
    };

    const handleTriesChange = (count) => {
        setTries(count);
    };

    const getTiles = () => {
        if (selectedGame?.tiles?.length > 0) {
            let tiles = [...selectedGame.tiles, ...selectedGame.tiles];
            return tiles.map((card, index) => ({
                ...card,
                order: Math.floor(Math.random() * tiles.length),
                isFlipped: false,
                id: index,
                originalId: card.id,
            }));
        }
        return [];
    };
    const breakpointColumnsObj = {
        default: 3,
        1100: 3,
        700: 2,
        500: 1,
    };

    return (
        <Paper
            sx={{
                position: "relative",
                backgroundColor: "#000",
                color: "#fff",
                mb: 4,
                height: "100%",
                zIndex: 1,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                maxWidth: "1200px",
                margin: isDesktop ? "auto" : "100px auto",
            }}>
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    backgroundColor: "rgba(0,0,0,.3)",
                }}
            />
            <Grid container sx={{ paddingBottom: "6rem" }}>
                <Grid item md={12}>
                    <Box
                        sx={{
                            position: "relative",
                            pt: { xs: 3, lg: 6 },
                            pr: { xs: 3, lg: 0 },
                            pl: { xs: 3, lg: 0 },
                        }}>
                        <h1 className={`fade-in ${displayImages ? "show" : ""}`}>MEMORY GAMES</h1>

                        <p className={`h3 fade-in-2 ${displayImages ? "show" : ""}`}>
                            Fresh Artists’ online,{" "}
                            <span style={{ fontFamily: "Stakkat, sans-serif", fontStyle: "italic" }}>
                                matching games to play on computers, tablets and smart phones.
                            </span>{" "}
                            Play games featuring our student's art work, or submit your own game today!
                        </p>
                        <Box
                            sx={{
                                top: 0,
                                left: 0,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                            className={` fade-in-3 ${displayImages ? "show" : ""}`}>
                            {noRecordFound && (
                                <Box>
                                    <h4
                                        style={{
                                            width: "100%",
                                            color: "white",
                                            fontSize: "1.2rem",
                                            textAlign: "center",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "300px",
                                        }}>
                                        No record found.
                                    </h4>
                                </Box>
                            )}
                            {!noRecordFound && (
                                <>
                                    {games?.length > 0 ? (
                                        <Grid
                                            container
                                            spacing={3}
                                            sx={{ mt: "1rem", justifyContent: "left", width: "100%" }}>
                                            {games?.map((game) => (
                                                <Grid item xs={6} lg={4}>
                                                    <GameCard
                                                        game={game}
                                                        onPlay={(item) => handlePlay(item)}></GameCard>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    ) : (
                                        <Box sx={{ mt: "1rem", justifyContent: "left", width: "100%" }}>
                                            <ElementFadeIn>
                                                <Box
                                                    sx={{
                                                        width: "100%",
                                                        top: 0,
                                                        left: 0,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                    }}>
                                                    <Masonry
                                                        style={{ marginTop: "18px", opacity: displayImages ? 1 : 0 }}
                                                        breakpointCols={breakpointColumnsObj}
                                                        className="my-masonry-grid"
                                                        columnClassName="my-masonry-grid_column">
                                                        <Skeleton
                                                            variant="rectangular"
                                                            width={"100%"}
                                                            height={md ? 300 : sm ? 200 : 400}
                                                            sx={{ backgroundColor: "#3e3e3e", mt: "10px" }}
                                                        />
                                                        <Skeleton
                                                            variant="rectangular"
                                                            width={"100%"}
                                                            height={md ? 250 : sm ? 170 : 300}
                                                            sx={{ backgroundColor: "#3e3e3e", mt: "10px" }}
                                                        />
                                                        <Skeleton
                                                            variant="rectangular"
                                                            width={"100%"}
                                                            height={md ? 325 : sm ? 230 : 450}
                                                            sx={{ backgroundColor: "#3e3e3e", mt: "10px" }}
                                                        />
                                                    </Masonry>
                                                </Box>
                                            </ElementFadeIn>
                                        </Box>
                                    )}
                                </>
                            )}
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <Modal
                open={openImageModal}
                fixedTitle={true}
                textTitle={selectedGame?.name}
                title={
                    <Box
                        sx={{
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            maxHeight: sm ? "115px" : "120px",
                        }}>
                        <Box sx={{ margin: "auto", textAlign: "center" }}>
                            <h3>{selectedGame?.name}</h3>
                            <h5
                                style={{
                                    marginTop: "8px",
                                    display: "flex",
                                    width: "380px",
                                    margin: "auto",
                                    justifyContent: "space-between",
                                }}>
                                <Box sx={{ width: "190px" }}>
                                    <Timer></Timer>
                                </Box>
                                <span style={{ marginLeft: "20px", width: "100px" }}>Tries: {tries}</span>
                            </h5>
                            <h3 style={{ visibility: "hidden" }}>{selectedGame?.name}</h3>
                        </Box>
                    </Box>
                }
                onClose={() => {
                    handleCloseModal();
                }}
                fullScreen={true}
                maxWidth="lg"
                hideActions={true}
                hideTitle={false}>
                <div style={{ padding: sm ? "1rem" : "0", marginTop: "70px" }}>
                    <div className={`cms-hm-image modal-fade-in ${displayModalContent ? "show" : ""}`}>
                        <Game cardsData={getTiles()} onTriesChange={handleTriesChange}></Game>
                    </div>
                </div>
            </Modal>
        </Paper>
    );
};

export { GameList };
